import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../lib/api";
import { formatApiErrorDetail } from "../context/AuthContext";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    if (pw.length < 8) { toast.error("Use at least 8 characters"); return; }
    setLoading(true);
    try {
      await resetPassword({ token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2400);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center relative z-10 px-6 pt-28 pb-16">
      <div className="w-full max-w-md">
        <p className="overline text-[#9A7420] mb-3 text-center">Set a new password</p>
        <h1 className="font-display text-5xl tracking-tight text-center mb-10">Welcome back</h1>

        {!token ? (
          <div className="bg-white border border-[#DAD5E2] rounded-2xl p-8 text-center" data-testid="rp-missing-token">
            <p className="text-[#57515F] mb-4">This link is missing a token. Please request a new one.</p>
            <Link to="/forgot-password" className="text-[#9A7420] underline text-sm">Request a new reset link</Link>
          </div>
        ) : done ? (
          <div className="bg-white border border-[#DAD5E2] rounded-2xl p-8 text-center" data-testid="rp-done">
            <CheckCircle2 className="w-10 h-10 text-[#9A7420] mx-auto mb-4" strokeWidth={1.5} />
            <p className="font-display text-2xl mb-2">Password updated</p>
            <p className="text-sm text-[#57515F]">Redirecting you to sign in…</p>
          </div>
        ) : (
          <form data-testid="reset-form" onSubmit={submit} className="space-y-7">
            <div>
              <label className="overline block mb-2">New Password</label>
              <input data-testid="rp-pw" type="password" required minLength={8} className="input-line"
                value={pw} onChange={(e) => setPw(e.target.value)} />
            </div>
            <div>
              <label className="overline block mb-2">Confirm Password</label>
              <input data-testid="rp-pw2" type="password" required minLength={8} className="input-line"
                value={pw2} onChange={(e) => setPw2(e.target.value)} />
            </div>
            <button data-testid="rp-submit" type="submit" disabled={loading}
              className="btn-primary w-full justify-center">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
